// AUTO-GENERIERT (gen_support_i18n.py): Support- & Kunde-anlegen-Strings + Backend-Labels.
// Schluessel = deutscher UI-Text, Wert = { fr, it, en }. Manuelles Ueberschreiben jederzeit moeglich.
const support2 = {
  "Export erstellt": {
    "fr": "Export créé",
    "it": "Esportazione creata",
    "en": "Export created"
  },
  "Export fehlgeschlagen.": {
    "fr": "Échec de l’export.",
    "it": "Esportazione fallita.",
    "en": "Export failed."
  },
  "Support": {
    "fr": "Support",
    "it": "Supporto",
    "en": "Support"
  },
  "Ein echtes Ticket-System — keine Anfrage geht verloren.": {
    "fr": "Un véritable système de tickets — aucune demande n’est perdue.",
    "it": "Un vero sistema di ticket — nessuna richiesta va persa.",
    "en": "A real ticket system — no request is lost."
  },
  "Exportieren": {
    "fr": "Exporter",
    "it": "Esporta",
    "en": "Export"
  },
  "Neuer Supportfall": {
    "fr": "Nouveau ticket support",
    "it": "Nuovo caso supporto",
    "en": "New support case"
  },
  "Nur-Lese-Zugriff — Ihre Rolle darf Supportfälle ansehen, aber nicht bearbeiten.": {
    "fr": "Accès lecture seule — votre rôle permet de voir les tickets, pas de les modifier.",
    "it": "Solo lettura — il tuo ruolo consente di vedere, ma non modificare i casi supporto.",
    "en": "Read-only access — your role can view support cases but not edit them."
  },
  "Betreff, Kunde, Ticket-Nr., E-Mail…": {
    "fr": "Sujet, client, n° de ticket, e-mail…",
    "it": "Oggetto, cliente, numero ticket, email…",
    "en": "Subject, customer, ticket no., email…"
  },
  "Status: Alle": {
    "fr": "Statut : Tous",
    "it": "Stato: Tutti",
    "en": "Status: All"
  },
  "Nur offene": {
    "fr": "Seulement ouverts",
    "it": "Solo aperti",
    "en": "Open only"
  },
  "Priorität: Alle": {
    "fr": "Priorité : Toutes",
    "it": "Priorità: Tutti",
    "en": "Priority: All"
  },
  "Zuständig: Alle": {
    "fr": "Responsable : Tous",
    "it": "Responsabile: Tutti",
    "en": "Responsible: All"
  },
  "Kunde: Alle": {
    "fr": "Client : Tous",
    "it": "Cliente: Tutti",
    "en": "Customer: All"
  },
  "Paket: Alle": {
    "fr": "Forfait : Tous",
    "it": "Pacchetto: Tutti",
    "en": "Package: All"
  },
  "SLA: Alle": {
    "fr": "SLA : Tous",
    "it": "SLA: Tutti",
    "en": "SLA: All"
  },
  "Gefährdet": {
    "fr": "En danger",
    "it": "A rischio",
    "en": "At risk"
  },
  "Überfällig": {
    "fr": "En retard",
    "it": "In ritardo",
    "en": "Overdue"
  },
  "Bald fällig": {
    "fr": "Bientôt dû",
    "it": "Scadenza imminente",
    "en": "Due soon"
  },
  "Im Zeitplan": {
    "fr": "Dans les temps",
    "it": "In orario",
    "en": "On schedule"
  },
  "Zeitraum: Alle": {
    "fr": "Période : Toutes",
    "it": "Periodo: Tutti",
    "en": "Period: All"
  },
  "Heute": {
    "fr": "Aujourd’hui",
    "it": "Oggi",
    "en": "Today"
  },
  "7 Tage": {
    "fr": "7 jours",
    "it": "7 giorni",
    "en": "7 days"
  },
  "30 Tage": {
    "fr": "30 jours",
    "it": "30 giorni",
    "en": "30 days"
  },
  "Neueste zuerst": {
    "fr": "Les plus récents d’abord",
    "it": "Più recenti prima",
    "en": "Newest first"
  },
  "Nach Priorität": {
    "fr": "Par priorité",
    "it": "Per priorità",
    "en": "By priority"
  },
  "Nach SLA": {
    "fr": "Par SLA",
    "it": "Per SLA",
    "en": "By SLA"
  },
  "Nach Kunde": {
    "fr": "Par client",
    "it": "Per cliente",
    "en": "By customer"
  },
  "Zurücksetzen": {
    "fr": "Réinitialiser",
    "it": "Reimposta",
    "en": "Reset"
  },
  "Ticket-Queue": {
    "fr": "File d’attente des tickets",
    "it": "Coda ticket",
    "en": "Ticket queue"
  },
  "Keine Supportfälle in dieser Ansicht.": {
    "fr": "Aucun ticket support dans cette vue.",
    "it": "Nessun caso supporto in questa vista.",
    "en": "No support cases in this view."
  },
  "Wählen Sie links einen Supportfall aus.": {
    "fr": "Sélectionnez un ticket support à gauche.",
    "it": "Seleziona un caso supporto a sinistra.",
    "en": "Select a support case on the left."
  },
  "Kontext erscheint hier.": {
    "fr": "Le contexte apparaît ici.",
    "it": "Il contesto appare qui.",
    "en": "Context appears here."
  },
  "Paket prüfen": {
    "fr": "Vérifier le forfait",
    "it": "Controlla pacchetto",
    "en": "Check package"
  },
  "Gespeichert": {
    "fr": "Enregistré",
    "it": "Salvato",
    "en": "Saved"
  },
  "Konnte nicht speichern.": {
    "fr": "Échec de l’enregistrement.",
    "it": "Impossibile salvare.",
    "en": "Could not save."
  },
  "Status aktualisiert": {
    "fr": "Statut mis à jour",
    "it": "Stato aggiornato",
    "en": "Status updated"
  },
  "Datei hochgeladen": {
    "fr": "Fichier téléchargé",
    "it": "File caricato",
    "en": "File uploaded"
  },
  "Upload fehlgeschlagen.": {
    "fr": "Échec du téléchargement.",
    "it": "Caricamento fallito.",
    "en": "Upload failed."
  },
  "Download fehlgeschlagen.": {
    "fr": "Échec du téléchargement.",
    "it": "Download fallito.",
    "en": "Download failed."
  },
  "Antwort darf nicht leer sein.": {
    "fr": "La réponse ne peut pas être vide.",
    "it": "La risposta non può essere vuota.",
    "en": "Response cannot be empty."
  },
  "Interne Notiz gespeichert": {
    "fr": "Note interne enregistrée",
    "it": "Nota interna salvata",
    "en": "Internal note saved"
  },
  "Antwort gesendet": {
    "fr": "Réponse envoyée",
    "it": "Risposta inviata",
    "en": "Response sent"
  },
  "Konnte nicht senden.": {
    "fr": "Échec de l’envoi.",
    "it": "Impossibile inviare.",
    "en": "Could not send."
  },
  "Konnte Notiz nicht speichern.": {
    "fr": "Impossible d’enregistrer la note.",
    "it": "Impossibile salvare nota.",
    "en": "Could not save note."
  },
  "Zurück zur Queue": {
    "fr": "Retour à la file",
    "it": "Torna alla coda",
    "en": "Back to queue"
  },
  "Zuständig:": {
    "fr": "Responsable :",
    "it": "Responsabile:",
    "en": "Responsible:"
  },
  "Priorität aktualisiert": {
    "fr": "Priorité mise à jour",
    "it": "Priorità aggiornata",
    "en": "Priority updated"
  },
  "Zugewiesen": {
    "fr": "Assigné",
    "it": "Assegnato",
    "en": "Assigned"
  },
  "Antworten": {
    "fr": "Réponses",
    "it": "Risposte",
    "en": "Responses"
  },
  "Aufgabe": {
    "fr": "Tâche",
    "it": "Attività",
    "en": "Task"
  },
  "Als erledigt markiert": {
    "fr": "Marqué comme terminé",
    "it": "Segnato come completato",
    "en": "Marked as done"
  },
  "Schliessen": {
    "fr": "Fermer",
    "it": "Chiudi",
    "en": "Close"
  },
  "Archiviert": {
    "fr": "Archivé",
    "it": "Archiviato",
    "en": "Archived"
  },
  "Archivieren": {
    "fr": "Archiver",
    "it": "Archivia",
    "en": "Archive"
  },
  "KEWAG": {
    "fr": "KEWAG",
    "it": "KEWAG",
    "en": "KEWAG"
  },
  "Kunde": {
    "fr": "Client",
    "it": "Cliente",
    "en": "Customer"
  },
  "Anhang": {
    "fr": "Pièce jointe",
    "it": "Allegato",
    "en": "Attachment"
  },
  "Anhang öffnen": {
    "fr": "Ouvrir la pièce jointe",
    "it": "Apri allegato",
    "en": "Open attachment"
  },
  "Noch keine Nachrichten.": {
    "fr": "Pas encore de messages.",
    "it": "Nessun messaggio ancora.",
    "en": "No messages yet."
  },
  "Nur für KEWAG sichtbar — der Kunde sieht diese Notizen niemals.": {
    "fr": "Visible seulement par KEWAG — le client ne verra jamais ces notes.",
    "it": "Visibile solo a KEWAG — il cliente non vede mai queste note.",
    "en": "Visible to KEWAG only — the customer never sees these notes."
  },
  "Noch keine internen Notizen.": {
    "fr": "Pas encore de notes internes.",
    "it": "Ancora nessuna nota interna.",
    "en": "No internal notes yet."
  },
  "Interne Notiz hinzufügen…": {
    "fr": "Ajouter une note interne…",
    "it": "Aggiungi nota interna…",
    "en": "Add internal note…"
  },
  "Notiz": {
    "fr": "Note",
    "it": "Nota",
    "en": "Note"
  },
  "Noch keine verknüpften Aufgaben.": {
    "fr": "Pas encore de tâches liées.",
    "it": "Ancora nessun compito collegato.",
    "en": "No linked tasks yet."
  },
  "Fällig": {
    "fr": "Échéance",
    "it": "Scadenza",
    "en": "Due"
  },
  "Aufgabe erstellen": {
    "fr": "Créer une tâche",
    "it": "Crea compito",
    "en": "Create task"
  },
  "Noch keine Dateien angehängt.": {
    "fr": "Aucun fichier joint.",
    "it": "Ancora nessun file allegato.",
    "en": "No files attached yet."
  },
  "Download": {
    "fr": "Télécharger",
    "it": "Scarica",
    "en": "Download"
  },
  "Datei hochladen": {
    "fr": "Téléverser un fichier",
    "it": "Carica file",
    "en": "Upload file"
  },
  "Erlaubt: PDF, Bilder, Office, ZIP, TXT — max. 15 MB.": {
    "fr": "Formats autorisés : PDF, images, Office, ZIP, TXT — max. 15 Mo.",
    "it": "Consentito: PDF, immagini, Office, ZIP, TXT — max. 15 MB.",
    "en": "Allowed: PDF, images, Office, ZIP, TXT — max. 15 MB."
  },
  "Noch keine Einträge.": {
    "fr": "Aucune entrée.",
    "it": "Ancora nessuna voce.",
    "en": "No entries yet."
  },
  "Öffentliche Antwort": {
    "fr": "Réponse publique",
    "it": "Risposta pubblica",
    "en": "Public reply"
  },
  "Interne Notiz": {
    "fr": "Note interne",
    "it": "Nota interna",
    "en": "Internal note"
  },
  "Interne Notiz schreiben…": {
    "fr": "Écrire une note interne…",
    "it": "Scrivi nota interna…",
    "en": "Write internal note…"
  },
  "Antwort an den Kunden schreiben…": {
    "fr": "Écrire une réponse au client…",
    "it": "Scrivi risposta al cliente…",
    "en": "Write reply to customer…"
  },
  "Datei anhängen": {
    "fr": "Joindre un fichier",
    "it": "Allega file",
    "en": "Attach file"
  },
  "Notiz speichern": {
    "fr": "Enregistrer la note",
    "it": "Salva nota",
    "en": "Save note"
  },
  "Antwort senden": {
    "fr": "Envoyer la réponse",
    "it": "Invia risposta",
    "en": "Send reply"
  },
  "Ticket-Informationen": {
    "fr": "Informations sur le ticket",
    "it": "Informazioni ticket",
    "en": "Ticket information"
  },
  "Erstellt am": {
    "fr": "Créé le",
    "it": "Creato il",
    "en": "Created on"
  },
  "Letzte Aktivität": {
    "fr": "Dernière activité",
    "it": "Ultima attività",
    "en": "Last activity"
  },
  "Erstellt von": {
    "fr": "Créé par",
    "it": "Creato da",
    "en": "Created by"
  },
  "SLA-Status": {
    "fr": "Statut SLA",
    "it": "Stato SLA",
    "en": "SLA status"
  },
  "Antwortfrist": {
    "fr": "Délai de réponse",
    "it": "Termine risposta",
    "en": "Response deadline"
  },
  "Kunde öffnen": {
    "fr": "Ouvrir le client",
    "it": "Apri cliente",
    "en": "Open customer"
  },
  "Paket & Vertrag": {
    "fr": "Forfait & contrat",
    "it": "Pacchetto & contratto",
    "en": "Package & contract"
  },
  "Paket": {
    "fr": "Forfait",
    "it": "Pacchetto",
    "en": "Package"
  },
  "Monatlich": {
    "fr": "Mensuel",
    "it": "Mensile",
    "en": "Monthly"
  },
  "Laufzeit": {
    "fr": "Durée",
    "it": "Durata",
    "en": "Duration"
  },
  "Monate": {
    "fr": "Mois",
    "it": "Mesi",
    "en": "Months"
  },
  "Vertrag bis": {
    "fr": "Contrat jusqu’au",
    "it": "Contratto fino a",
    "en": "Contract until"
  },
  "Gebuchte Module": {
    "fr": "Modules réservés",
    "it": "Moduli prenotati",
    "en": "Booked modules"
  },
  "Paketdetails öffnen": {
    "fr": "Ouvrir les détails du forfait",
    "it": "Apri dettagli pacchetto",
    "en": "Open package details"
  },
  "Anhänge": {
    "fr": "Pièces jointes",
    "it": "Allegati",
    "en": "Attachments"
  },
  "Keine Dateien.": {
    "fr": "Aucun fichier.",
    "it": "Nessun file.",
    "en": "No files."
  },
  "Verknüpfte Aufgaben": {
    "fr": "Tâches liées",
    "it": "Compiti collegati",
    "en": "Linked tasks"
  },
  "Keine offenen Aufgaben.": {
    "fr": "Aucune tâche ouverte.",
    "it": "Nessun compito aperto.",
    "en": "No open tasks."
  },
  "Aktivität": {
    "fr": "Activité",
    "it": "Attività",
    "en": "Activity"
  },
  "Keine Einträge.": {
    "fr": "Aucune entrée.",
    "it": "Nessuna voce.",
    "en": "No entries."
  },
  "Kunde / Projekt fehlt.": {
    "fr": "Client / projet manquant.",
    "it": "Cliente / progetto mancante.",
    "en": "Customer / project missing."
  },
  "Betreff fehlt.": {
    "fr": "Objet manquant.",
    "it": "Oggetto mancante.",
    "en": "Subject missing."
  },
  "Nachricht fehlt.": {
    "fr": "Message manquant.",
    "it": "Messaggio mancante.",
    "en": "Message missing."
  },
  "Hohe oder kritische Priorität benötigt eine zuständige Person.": {
    "fr": "Une priorité élevée ou critique nécessite une personne responsable.",
    "it": "Priorità alta o critica richiede una persona responsabile.",
    "en": "High or critical priority requires an assignee."
  },
  "Bitte Pflichtfelder prüfen.": {
    "fr": "Veuillez vérifier les champs obligatoires.",
    "it": "Controlla i campi obbligatori.",
    "en": "Please check required fields."
  },
  "Supportfall erstellt": {
    "fr": "Cas de support créé",
    "it": "Caso di supporto creato",
    "en": "Support case created"
  },
  "Kunde / Projekt *": {
    "fr": "Client / projet *",
    "it": "Cliente / progetto *",
    "en": "Customer / project *"
  },
  "— wählen —": {
    "fr": "— choisir —",
    "it": "— seleziona —",
    "en": "— select —"
  },
  "Kategorie": {
    "fr": "Catégorie",
    "it": "Categoria",
    "en": "Category"
  },
  "Betreff *": {
    "fr": "Objet *",
    "it": "Oggetto *",
    "en": "Subject *"
  },
  "Worum geht es?": {
    "fr": "De quoi s'agit-il ?",
    "it": "Di cosa si tratta?",
    "en": "What is it about?"
  },
  "Nachricht *": {
    "fr": "Message *",
    "it": "Messaggio *",
    "en": "Message *"
  },
  "Details zum Supportfall…": {
    "fr": "Détails du cas de support…",
    "it": "Dettagli sul caso di supporto…",
    "en": "Support case details…"
  },
  "Priorität": {
    "fr": "Priorité",
    "it": "Priorità",
    "en": "Priority"
  },
  "Status": {
    "fr": "Statut",
    "it": "Stato",
    "en": "Status"
  },
  "Zuständige Person": {
    "fr": "Personne responsable",
    "it": "Persona responsabile",
    "en": "Assignee"
  },
  "Fälligkeit": {
    "fr": "Échéance",
    "it": "Scadenza",
    "en": "Due date"
  },
  "Interne Notiz (nur KEWAG)": {
    "fr": "Note interne (KEWAG uniquement)",
    "it": "Nota interna (solo KEWAG)",
    "en": "Internal note (KEWAG only)"
  },
  "Optional, nur intern sichtbar…": {
    "fr": "Optionnel, visible uniquement en interne…",
    "it": "Opzionale, visibile solo internamente…",
    "en": "Optional, internal only…"
  },
  "Abbrechen": {
    "fr": "Annuler",
    "it": "Annulla",
    "en": "Cancel"
  },
  "Speichern…": {
    "fr": "Enregistrer…",
    "it": "Salva…",
    "en": "Saving…"
  },
  "Supportfall erstellen": {
    "fr": "Créer un cas de support",
    "it": "Crea caso di supporto",
    "en": "Create support case"
  },
  "Support: {x}": {
    "fr": "Support : {x}",
    "it": "Supporto: {x}",
    "en": "Support: {x}"
  },
  "Supportfall lösen": {
    "fr": "Résoudre le cas de support",
    "it": "Risolvere caso di supporto",
    "en": "Resolve support case"
  },
  "Aufgabe erstellt": {
    "fr": "Tâche créée",
    "it": "Compito creato",
    "en": "Task created"
  },
  "Konnte Aufgabe nicht erstellen.": {
    "fr": "Impossible de créer la tâche.",
    "it": "Impossibile creare il compito.",
    "en": "Could not create task."
  },
  "Aufgabe aus Supportfall": {
    "fr": "Tâche du cas de support",
    "it": "Compito dal caso di supporto",
    "en": "Task from support case"
  },
  "Titel": {
    "fr": "Titre",
    "it": "Titolo",
    "en": "Title"
  },
  "Nächste Aktion": {
    "fr": "Prochaine action",
    "it": "Prossima azione",
    "en": "Next action"
  },
  "Kunde, Betreff, Nachricht, Kategorie und Ticket-Verknüpfung werden automatisch übernommen. Die Aufgabe ist intern (KEWAG).": {
    "fr": "Client, sujet, message, catégorie et lien du ticket sont repris automatiquement. La tâche est interne (KEWAG).",
    "it": "Cliente, oggetto, messaggio, categoria e collegamento ticket sono inseriti automaticamente. Il compito è interno (KEWAG).",
    "en": "Customer, subject, message, category, and ticket link are automatically filled. The task is internal (KEWAG)."
  },
  "Kunde am Zug": {
    "fr": "Tour du client",
    "it": "Tocca al cliente",
    "en": "Customer's turn"
  },
  "Bitte zuerst die Pflichtfelder ausfüllen.": {
    "fr": "Veuillez d'abord remplir les champs obligatoires.",
    "it": "Per favore compila prima i campi obbligatori.",
    "en": "Please fill in required fields first."
  },
  "Alle Pflichtfelder erfüllt — bereit zum Erstellen.": {
    "fr": "Tous les champs obligatoires remplis — prêt à créer.",
    "it": "Tutti i campi obbligatori compilati — pronto per la creazione.",
    "en": "All required fields completed — ready to create."
  },
  "Unbenannter Entwurf": {
    "fr": "Brouillon non nommé",
    "it": "Bozza senza nome",
    "en": "Unnamed draft"
  },
  "Entwurf gespeichert": {
    "fr": "Brouillon enregistré",
    "it": "Bozza salvata",
    "en": "Draft saved"
  },
  "Entwurf konnte nicht gespeichert werden": {
    "fr": "Impossible d’enregistrer le brouillon",
    "it": "Impossibile salvare la bozza",
    "en": "Could not save draft"
  },
  "Entwurf geladen": {
    "fr": "Brouillon chargé",
    "it": "Bozza caricata",
    "en": "Draft loaded"
  },
  "Entwurf konnte nicht geladen werden": {
    "fr": "Impossible de charger le brouillon",
    "it": "Impossibile caricare la bozza",
    "en": "Could not load draft"
  },
  "Entwurf verworfen": {
    "fr": "Brouillon supprimé",
    "it": "Bozza scartata",
    "en": "Draft discarded"
  },
  "Fehler beim Anlegen": {
    "fr": "Erreur lors de la création",
    "it": "Errore durante la creazione",
    "en": "Error creating"
  },
  "Kunde wurde erstellt.": {
    "fr": "Client créé.",
    "it": "Cliente creato.",
    "en": "Customer created."
  },
  "Cockpit, Standardmodule, erste Aufgabe und Protokoll-Eintrag wurden automatisch angelegt.": {
    "fr": "Cockpit, modules standards, première tâche et entrée du journal ont été créés automatiquement.",
    "it": "Cockpit, moduli standard, primo compito e inserimento protocollo creati automaticamente.",
    "en": "Cockpit, standard modules, first task, and log entry created automatically."
  },
  "Eine bexio-Rechnung wurde vorbereitet.": {
    "fr": "Une facture bexio a été préparée.",
    "it": "Una fattura bexio è stata preparata.",
    "en": "A bexio invoice has been prepared."
  },
  "Kopiert": {
    "fr": "Copié",
    "it": "Copiato",
    "en": "Copied"
  },
  "Setup": {
    "fr": "Installation",
    "it": "Setup",
    "en": "Setup"
  },
  "/ Monat": {
    "fr": "/ mois",
    "it": "/ mese",
    "en": "/ month"
  },
  "auf Anfrage": {
    "fr": "sur demande",
    "it": "su richiesta",
    "en": "on request"
  },
  "frei wählbar": {
    "fr": "choix libre",
    "it": "a scelta libera",
    "en": "freely selectable"
  },
  "Paket & Preis prüfen": {
    "fr": "Vérifier paquet & prix",
    "it": "Controlla pacchetto e prezzo",
    "en": "Check package & price"
  },
  "Ausgewähltes Paket": {
    "fr": "Pack sélectionné",
    "it": "Pacchetto selezionato",
    "en": "Selected package"
  },
  "inkl. MWST": {
    "fr": "TTC",
    "it": "IVA inclusa",
    "en": "incl. VAT"
  },
  "Paketpreis / Monat": {
    "fr": "Prix du paquet / mois",
    "it": "Prezzo pacchetto / mese",
    "en": "Package price / month"
  },
  "nach Offerte": {
    "fr": "selon offre",
    "it": "secondo offerta",
    "en": "per quote"
  },
  "Setup-Preis": {
    "fr": "Prix d’installation",
    "it": "Prezzo setup",
    "en": "Setup price"
  },
  "Zusatzmodule / Monat": {
    "fr": "Modules supplémentaires / mois",
    "it": "Moduli aggiuntivi / mese",
    "en": "Additional modules / month"
  },
  "Zusatzkosten einmalig": {
    "fr": "Coûts supplémentaires uniques",
    "it": "Costi aggiuntivi una tantum",
    "en": "One-time additional costs"
  },
  "Total monatlich": {
    "fr": "Total mensuel",
    "it": "Totale mensile",
    "en": "Total monthly"
  },
  "Setup einmalig": {
    "fr": "Installation unique",
    "it": "Setup una tantum",
    "en": "One-time setup"
  },
  "Gesamtwert {n} Monate": {
    "fr": "Valeur totale {n} mois",
    "it": "Valore totale {n} mesi",
    "en": "Total value {n} months"
  },
  "Inklusive Module": {
    "fr": "Modules inclus",
    "it": "Moduli inclusi",
    "en": "Included modules"
  },
  "Freie Auswahl": {
    "fr": "Choix libre",
    "it": "Scelta libera",
    "en": "Free selection"
  },
  "Zusatzmodule": {
    "fr": "Modules supplémentaires",
    "it": "Moduli aggiuntivi",
    "en": "Additional modules"
  },
  "Vorbereitete Empfehlungen": {
    "fr": "Recommandations préparées",
    "it": "Raccomandazioni preparate",
    "en": "Prepared recommendations"
  },
  "Offerte": {
    "fr": "Offre",
    "it": "Offerta",
    "en": "Quote"
  },
  "Individuelle Offerten": {
    "fr": "Offres personnalisées",
    "it": "Offerte personalizzate",
    "en": "Individual quotes"
  },
  "separates Angebot": {
    "fr": "proposition séparée",
    "it": "offerta separata",
    "en": "Separate offer"
  },
  "Kunde prüfen & erstellen": {
    "fr": "Vérifier & créer client",
    "it": "Verifica e crea cliente",
    "en": "Review & create customer"
  },
  "Bitte alle Angaben vor dem endgültigen Erstellen kontrollieren.": {
    "fr": "Veuillez vérifier toutes les informations avant la création finale.",
    "it": "Per favore controlla tutte le informazioni prima della creazione finale.",
    "en": "Please check all details before final creation."
  },
  "Kundendaten": {
    "fr": "Données client",
    "it": "Dati cliente",
    "en": "Customer data"
  },
  "Firmenname": {
    "fr": "Nom de l’entreprise",
    "it": "Ragione sociale",
    "en": "Company name"
  },
  "Branche": {
    "fr": "Secteur",
    "it": "Settore",
    "en": "Industry"
  },
  "Ansprechpartner": {
    "fr": "Contact",
    "it": "Referente",
    "en": "Contact person"
  },
  "E-Mail": {
    "fr": "E-mail",
    "it": "E-mail",
    "en": "Email"
  },
  "Telefon": {
    "fr": "Téléphone",
    "it": "Telefono",
    "en": "Phone"
  },
  "Adresse": {
    "fr": "Adresse",
    "it": "Indirizzo",
    "en": "Address"
  },
  "Domain": {
    "fr": "Domaine",
    "it": "Dominio",
    "en": "Domain"
  },
  "App-Domain": {
    "fr": "Domaine de l’app",
    "it": "Dominio app",
    "en": "App domain"
  },
  "Module": {
    "fr": "Modules",
    "it": "Moduli",
    "en": "Modules"
  },
  "inkl.": {
    "fr": "incl.",
    "it": "incl.",
    "en": "incl."
  },
  "bexio-Rechnung wird vorbereitet (Setup + 1. Monat).": {
    "fr": "Facture bexio en préparation (installation + 1er mois).",
    "it": "Fattura bexio in preparazione (setup + 1° mese).",
    "en": "bexio invoice being prepared (setup + 1st month)."
  },
  "Manuelle Preisänderung:": {
    "fr": "Modification manuelle du prix :",
    "it": "Modifica prezzo manuale:",
    "en": "Manual price change:"
  },
  "Zurück bearbeiten": {
    "fr": "Revenir à la modification",
    "it": "Torna a modificare",
    "en": "Edit back"
  },
  "Erstellt…": {
    "fr": "Créé…",
    "it": "Creato…",
    "en": "Created…"
  },
  "Kunde endgültig erstellen": {
    "fr": "Créer le client définitivement",
    "it": "Crea cliente definitivamente",
    "en": "Create customer permanently"
  },
  "Firmenname / Projektname": {
    "fr": "Nom de l'entreprise / du projet",
    "it": "Nome azienda / nome progetto",
    "en": "Company / Project name"
  },
  "Kontaktperson": {
    "fr": "Personne de contact",
    "it": "Persona di contatto",
    "en": "Contact person"
  },
  "E-Mail gültig": {
    "fr": "Email valide",
    "it": "Email valida",
    "en": "Email valid"
  },
  "App-Domain (optional)": {
    "fr": "Domaine de l'app (optionnel)",
    "it": "Dominio app (opzionale)",
    "en": "App domain (optional)"
  },
  "Paket & Preis geprüft": {
    "fr": "Forfait & prix vérifiés",
    "it": "Pacchetto e prezzo verificati",
    "en": "Package & price checked"
  },
  "Domain noch frei (kein Duplikat)": {
    "fr": "Domaine encore disponible (pas de doublon)",
    "it": "Dominio ancora libero (nessun duplicato)",
    "en": "Domain still available (no duplicate)"
  },
  "Interne Notiz / nächste Aktion (Offerte)": {
    "fr": "Note interne / prochaine action (offre)",
    "it": "Nota interna / prossima azione (offerta)",
    "en": "Internal note / next action (offer)"
  },
  "Sicherer Kunden-Setup-Assistent — Paket, Module und Preis live prüfen.": {
    "fr": "Assistant de configuration client sécurisé — vérifier forfait, modules et prix en temps réel.",
    "it": "Assistente configurazione cliente sicuro — verifica pacchetto, moduli e prezzo in tempo reale.",
    "en": "Secure customer setup assistant — check package, modules, and price live."
  },
  "Kunde wird aus Lead „{name}\" erstellt — Daten wurden übernommen.": {
    "fr": "Client créé depuis le lead « {name} » — données importées.",
    "it": "Cliente creato da lead „{name}\" — dati importati.",
    "en": "Customer is created from lead „{name}\" — data has been transferred."
  },
  "Gespeicherter Entwurf gefunden": {
    "fr": "Brouillon enregistré trouvé",
    "it": "Bozza salvata trovata",
    "en": "Saved draft found"
  },
  "Unbenannt": {
    "fr": "Sans titre",
    "it": "Senza nome",
    "en": "Untitled"
  },
  "Entwurf laden": {
    "fr": "Charger le brouillon",
    "it": "Carica bozza",
    "en": "Load draft"
  },
  "Verwerfen": {
    "fr": "Rejeter",
    "it": "Annulla",
    "en": "Discard"
  },
  "Typ": {
    "fr": "Type",
    "it": "Tipo",
    "en": "Type"
  },
  "Zahlender Kunde": {
    "fr": "Client payant",
    "it": "Cliente pagante",
    "en": "Paying customer"
  },
  "Internes KEWAG-System (CHF 0)": {
    "fr": "Système KEWAG interne (CHF 0)",
    "it": "Sistema KEWAG interno (CHF 0)",
    "en": "Internal KEWAG system (CHF 0)"
  },
  "Testsystem (nur QA)": {
    "fr": "Système de test (QA uniquement)",
    "it": "Sistema di test (solo QA)",
    "en": "Test system (QA only)"
  },
  "Web & Domains": {
    "fr": "Web & domaines",
    "it": "Web & Domini",
    "en": "Web & domains"
  },
  "Kontakt": {
    "fr": "Contact",
    "it": "Contatto",
    "en": "Contact"
  },
  "Adresse (optional)": {
    "fr": "Adresse (optionnelle)",
    "it": "Indirizzo (opzionale)",
    "en": "Address (optional)"
  },
  "Strasse": {
    "fr": "Rue",
    "it": "Via",
    "en": "Street"
  },
  "PLZ": {
    "fr": "Code postal",
    "it": "CAP",
    "en": "ZIP"
  },
  "Ort": {
    "fr": "Localité",
    "it": "Località",
    "en": "City"
  },
  "Darstellung & Sprache": {
    "fr": "Affichage & langue",
    "it": "Visualizzazione & lingua",
    "en": "Display & language"
  },
  "Nächste Aktion (optional)": {
    "fr": "Prochaine action (optionnelle)",
    "it": "Prossima azione (opzionale)",
    "en": "Next action (optional)"
  },
  "Preise inkl. MWST · Laufzeit 24 Monate. WACHSTUM ist unsere Empfehlung.": {
    "fr": "Prix TTC · Durée 24 mois. WACHSTUM est notre recommandation.",
    "it": "Prezzi incl. MWST · Durata 24 mesi. WACHSTUM è la nostra raccomandazione.",
    "en": "Prices incl. VAT · Duration 24 months. GROWTH is our recommendation."
  },
  "Paket wählen": {
    "fr": "Choisir forfait",
    "it": "Seleziona pacchetto",
    "en": "Select package"
  },
  "Empfohlen": {
    "fr": "Recommandé",
    "it": "Consigliato",
    "en": "Recommended"
  },
  "Auf Anfrage": {
    "fr": "Sur demande",
    "it": "Su richiesta",
    "en": "On request"
  },
  "Offerte vorbereiten": {
    "fr": "Préparer l'offre",
    "it": "Prepara offerta",
    "en": "Prepare offer"
  },
  "Preis manuell anpassen": {
    "fr": "Ajuster le prix manuellement",
    "it": "Modifica prezzo manualmente",
    "en": "Adjust price manually"
  },
  "Monatspreis (CHF)": {
    "fr": "Prix mensuel (CHF)",
    "it": "Prezzo mensile (CHF)",
    "en": "Monthly price (CHF)"
  },
  "aus Paket": {
    "fr": "depuis le forfait",
    "it": "da pacchetto",
    "en": "from package"
  },
  "Setup-Gebühr (CHF)": {
    "fr": "Frais de configuration (CHF)",
    "it": "Spese di configurazione (CHF)",
    "en": "Setup fee (CHF)"
  },
  "Laufzeit (Monate)": {
    "fr": "Durée (mois)",
    "it": "Durata (mesi)",
    "en": "Duration (months)"
  },
  "Grund für manuelle Preisänderung (Pflicht bei Abweichung)": {
    "fr": "Motif de la modification manuelle du prix (obligatoire en cas d'écart)",
    "it": "Motivo modifica prezzo manuale (obbligatorio se differente)",
    "en": "Reason for manual price change (required if different)"
  },
  "Wird im Protokoll festgehalten (von → zu + Grund).": {
    "fr": "Enregistré dans le journal (de → à + motif).",
    "it": "Registrato nel protocollo (da → a + motivo).",
    "en": "Recorded in the log (from → to + reason)."
  },
  "Im Paket inklusive": {
    "fr": "Inclus dans le forfait",
    "it": "Incluso nel pacchetto",
    "en": "Included in package"
  },
  "Monatsreport Light": {
    "fr": "Rapport mensuel Light",
    "it": "Report mensile Light",
    "en": "Monthly report Light"
  },
  "Zusätzlich im {pkg} enthalten": {
    "fr": "Inclus en plus dans {pkg}",
    "it": "Incluso inoltre in {pkg}",
    "en": "Additionally included in {pkg}"
  },
  "INDIVIDUELL: Module frei wählbar — als Offerte vorbereiten.": {
    "fr": "INDIVIDUEL : modules librement sélectionnables — préparer comme offre.",
    "it": "PERSONALIZZATO: moduli liberamente selezionabili — preparare come offerta.",
    "en": "CUSTOM: Modules freely selectable — prepare as offer."
  },
  "Basis-Module (frei wählen)": {
    "fr": "Modules de base (choix libre)",
    "it": "Moduli base (scelta libera)",
    "en": "Basic modules (freely selectable)"
  },
  "Zusätzlicher Umsatz — sauber getrennt nach monatlich und einmalig.": {
    "fr": "Chiffre d'affaires supplémentaire — clairement séparé en mensuel et unique.",
    "it": "Ricavi aggiuntivi — separati nettamente per mensili e una tantum.",
    "en": "Additional revenue — clearly separated monthly and one-time."
  },
  "Zusatzmodule — separat verkaufbar": {
    "fr": "Modules additionnels — vente séparée",
    "it": "Moduli aggiuntivi — vendibili separatamente",
    "en": "Add-on modules — sold separately"
  },
  "Monatlich verrechnet": {
    "fr": "Facturé mensuellement",
    "it": "Fatturato mensilmente",
    "en": "Billed monthly"
  },
  "Einmalig verrechnet": {
    "fr": "Facturé une fois",
    "it": "Fatturato una tantum",
    "en": "Billed one-time"
  },
  "Eigenes Angebot — kein stiller CHF-0-Eintrag.": {
    "fr": "Offre propre — pas d'entrée silencieuse CHF 0.",
    "it": "Offerta personalizzata — nessuna voce CHF 0 silenziosa.",
    "en": "Custom offer — no silent CHF 0 entry."
  },
  "Empfehlung vorbereiten": {
    "fr": "Préparer la recommandation",
    "it": "Prepara raccomandazione",
    "en": "Prepare recommendation"
  },
  "Immer separate Offerte — Preis nach Aufwand.": {
    "fr": "Toujours offre séparée — prix selon effort.",
    "it": "Sempre offerta separata — prezzo a consumo.",
    "en": "Always separate offer — price by effort."
  },
  "Individuell offerieren": {
    "fr": "Offrir sur mesure",
    "it": "Offrire individualmente",
    "en": "Offer individually"
  },
  "Validierungs-Prüfliste": {
    "fr": "Liste de contrôle de validation",
    "it": "Lista di controllo validazione",
    "en": "Validation checklist"
  },
  "Interne Notizen": {
    "fr": "Notes internes",
    "it": "Note interne",
    "en": "Internal notes"
  },
  "Interne Notizen...": {
    "fr": "Notes internes…",
    "it": "Note interne...",
    "en": "Internal notes..."
  },
  "bexio-Rechnung vorbereiten (Setup + 1. Monat)": {
    "fr": "Préparer facture bexio (configuration + 1er mois)",
    "it": "Prepara fattura bexio (configurazione + 1° mese)",
    "en": "Prepare bexio invoice (Setup + 1st month)"
  },
  "Aktionen": {
    "fr": "Actions",
    "it": "Azioni",
    "en": "Actions"
  },
  "Prüfen & erstellen": {
    "fr": "Vérifier & créer",
    "it": "Verifica & crea",
    "en": "Check & create"
  },
  "Prüfen": {
    "fr": "Vérifier",
    "it": "Verifica",
    "en": "Check"
  },
  "Speichert…": {
    "fr": "Enregistrement…",
    "it": "Salvataggio…",
    "en": "Saving…"
  },
  "Entwurf speichern": {
    "fr": "Enregistrer le brouillon",
    "it": "Salva bozza",
    "en": "Save draft"
  },
  "Bitte zuerst alle roten Punkte beheben.": {
    "fr": "Veuillez d'abord corriger tous les points rouges.",
    "it": "Per favore risolvi prima tutti i punti rossi.",
    "en": "Please fix all red points first."
  },
  "Entscheidungshilfe": {
    "fr": "Aide à la décision",
    "it": "Guida alla decisione",
    "en": "Decision aid"
  },
  "Paketvergleich auf einen Blick": {
    "fr": "Comparaison des forfaits en un coup d'œil",
    "it": "Confronto pacchetti a colpo d’occhio",
    "en": "Package comparison at a glance"
  },
  "Leistungen im direkten Vergleich. WACHSTUM empfehlen wir für nachhaltiges Wachstum — „Auswählen“ übernimmt das Paket direkt in den Assistenten.": {
    "fr": "Prestations en comparaison directe. WACHSTUM est recommandé pour une croissance durable — « Sélectionner » applique directement le forfait dans l’assistant.",
    "it": "Servizi a confronto diretto. Raccomandiamo WACHSTUM per una crescita sostenibile — „Seleziona“ importa direttamente il pacchetto nell’assistente.",
    "en": "Services in direct comparison. We recommend WACHSTUM for sustainable growth — “Select” transfers the package directly into the assistant."
  },
  "nicht enthalten": {
    "fr": "non inclus",
    "it": "non incluso",
    "en": "not included"
  },
  "Leistung": {
    "fr": "Prestation",
    "it": "Servizio",
    "en": "Service"
  },
  "Gewählt": {
    "fr": "Sélectionné",
    "it": "Selezionato",
    "en": "Selected"
  },
  "Auswählen": {
    "fr": "Sélectionner",
    "it": "Seleziona",
    "en": "Select"
  },
  "Was bei KEWAGPage zusätzlich drin ist": {
    "fr": "Ce qui est en plus dans KEWAGPage",
    "it": "Cosa è incluso in più con KEWAGPage",
    "en": "What is additionally included in KEWAGPage"
  },
  "Der Unterschied zum reinen Website-Baukasten.": {
    "fr": "La différence par rapport au simple créateur de site.",
    "it": "La differenza rispetto al solo costruttore di siti.",
    "en": "The difference to a pure website builder."
  },
  "Neu": {
    "fr": "Nouveau",
    "it": "Nuovo",
    "en": "New"
  },
  "In Bearbeitung": {
    "fr": "En cours",
    "it": "In lavorazione",
    "en": "In progress"
  },
  "Warten auf Kunde": {
    "fr": "En attente du client",
    "it": "In attesa cliente",
    "en": "Waiting on client"
  },
  "Warten auf KEWAG": {
    "fr": "En attente de KEWAG",
    "it": "In attesa KEWAG",
    "en": "Waiting on KEWAG"
  },
  "Lösung vorgeschlagen": {
    "fr": "Solution proposée",
    "it": "Soluzione proposta",
    "en": "Solution proposed"
  },
  "Erledigt": {
    "fr": "Terminé",
    "it": "Completato",
    "en": "Done"
  },
  "Kritisch": {
    "fr": "Critique",
    "it": "Critico",
    "en": "Critical"
  },
  "Hoch": {
    "fr": "Élevé",
    "it": "Alto",
    "en": "High"
  },
  "Mittel": {
    "fr": "Moyen",
    "it": "Medio",
    "en": "Medium"
  },
  "Niedrig": {
    "fr": "Faible",
    "it": "Basso",
    "en": "Low"
  },
  "Wartet auf Kunde": {
    "fr": "En attente du client",
    "it": "In attesa cliente",
    "en": "Waiting on client"
  },
  "Website": {
    "fr": "Site web",
    "it": "Sito web",
    "en": "Website"
  },
  "Inhalt / Texte": {
    "fr": "Contenu / Textes",
    "it": "Contenuti / Testi",
    "en": "Content / Texts"
  },
  "Bilder": {
    "fr": "Images",
    "it": "Immagini",
    "en": "Images"
  },
  "Technik": {
    "fr": "Technique",
    "it": "Tecnologia",
    "en": "Technology"
  },
  "Domain / DNS": {
    "fr": "Domaine / DNS",
    "it": "Dominio / DNS",
    "en": "Domain / DNS"
  },
  "Rechnung": {
    "fr": "Facture",
    "it": "Fattura",
    "en": "Invoice"
  },
  "Login / Zugang": {
    "fr": "Connexion / Accès",
    "it": "Accesso / Login",
    "en": "Login / Access"
  },
  "Kunden-Cockpit": {
    "fr": "Cockpit client",
    "it": "Cockpit cliente",
    "en": "Client cockpit"
  },
  "Modul & Booster": {
    "fr": "Module & Booster",
    "it": "Modulo & Booster",
    "en": "Module & booster"
  },
  "Allgemeine Frage": {
    "fr": "Question générale",
    "it": "Domanda generale",
    "en": "General question"
  },
  "Sonstiges": {
    "fr": "Autres",
    "it": "Altro",
    "en": "Other"
  },
  "Anfrage": {
    "fr": "Demande",
    "it": "Richiesta",
    "en": "Request"
  },
  "Offen": {
    "fr": "Ouvert",
    "it": "Aperto",
    "en": "Open"
  },
  "In Arbeit": {
    "fr": "En cours",
    "it": "In corso",
    "en": "In progress"
  },
  "Prüfung / Freigabe": {
    "fr": "Contrôle / validation",
    "it": "Revisione / Approvazione",
    "en": "Review / Approval"
  },
  "nicht zugewiesen": {
    "fr": "non attribué",
    "it": "non assegnato",
    "en": "Unassigned"
  },
  "KEWAG Team": {
    "fr": "Équipe KEWAG",
    "it": "Team KEWAG",
    "en": "KEWAG team"
  },
  "SLA gefährdet": {
    "fr": "SLA menacé",
    "it": "SLA a rischio",
    "en": "SLA at risk"
  },
  "Supportfälle": {
    "fr": "Cas de support",
    "it": "Casi di supporto",
    "en": "Support cases"
  },
  "Hohe Priorität": {
    "fr": "Haute priorité",
    "it": "Alta priorità",
    "en": "High priority"
  },
  "Konversation": {
    "fr": "Conversation",
    "it": "Conversazione",
    "en": "Conversation"
  },
  "Dateien": {
    "fr": "Fichiers",
    "it": "File",
    "en": "Files"
  },
  "— Vorlage wählen —": {
    "fr": "— Choisir un modèle —",
    "it": "— Seleziona modello —",
    "en": "— Select template —"
  },
  "Eingang bestätigen": {
    "fr": "Confirmer la réception",
    "it": "Conferma Ricezione",
    "en": "Confirm receipt"
  },
  "Erledigt melden": {
    "fr": "Signaler comme terminé",
    "it": "Segnala completamento",
    "en": "Mark as done"
  },
  "Rückfrage stellen": {
    "fr": "Poser une question complémentaire",
    "it": "Fai una domanda",
    "en": "Ask follow-up question"
  },
  "Vielen Dank für Ihre Nachricht. Wir kümmern uns umgehend darum und melden uns in Kürze bei Ihnen.": {
    "fr": "Merci pour votre message. Nous nous en occupons immédiatement et revenons vers vous sous peu.",
    "it": "Grazie per il tuo messaggio. Ci occuperemo subito e ti risponderemo a breve.",
    "en": "Thank you for your message. We will handle it promptly and get back to you shortly."
  },
  "Wir haben Ihr Anliegen erledigt. Bitte prüfen Sie das Ergebnis und geben Sie uns kurz Bescheid, falls noch etwas offen ist.": {
    "fr": "Nous avons traité votre demande. Veuillez vérifier le résultat et nous informer brièvement si quelque chose reste à faire.",
    "it": "Abbiamo risolto la tua richiesta. Verifica il risultato e facci sapere brevemente se c’è ancora qualcosa da fare.",
    "en": "We have completed your request. Please review the result and let us know if anything remains open."
  },
  "Damit wir Ihnen rasch weiterhelfen können, haben wir eine kurze Rückfrage: ": {
    "fr": "Pour vous aider rapidement, nous avons une question : ",
    "it": "Per aiutarti rapidamente abbiamo una breve domanda:",
    "en": "To assist you quickly, we have a brief follow-up question: "
  },
  "Ihre Anfrage ist bei uns eingegangen und wird bearbeitet. Wir halten Sie auf dem Laufenden.": {
    "fr": "Votre demande a été reçue et est en traitement. Nous vous tiendrons informé.",
    "it": "La tua richiesta è stata ricevuta e viene elaborata. Ti terremo aggiornato.",
    "en": "Your request has been received and is being processed. We will keep you informed."
  },
  "Paket & Preis": {
    "fr": "Forfait & prix",
    "it": "Pacchetto & Prezzo",
    "en": "Package & price"
  },
  "Prüfung": {
    "fr": "Contrôle",
    "it": "Controllo",
    "en": "Review"
  },
  "Erstellen": {
    "fr": "Créer",
    "it": "Crea",
    "en": "Create"
  }
};

export default support2;
